import React from "react";
import CustomButton from "components/common/Button/CustomButton";
import ModalSkeleton from "components/Modals/ModalSkeleton";

const AvailabilityChangeModal = ({
  isShow,
  handleClose,
  handleConfirm,
  message,
}) => {
  const modalFooter = () => (
    <>
      <CustomButton
        label='Yes, proceed'
        //variant='success'
        clickHandler={handleConfirm}
      />
      <CustomButton
        label='No, cancel'
        variant='danger'
        clickHandler={handleClose}
      />
    </>
  );

  return (
    <>
      {isShow && (
        <ModalSkeleton
          title='Confirm Worker Access Change'
          cssClass='w-[50%]'
          isOpen={isShow}
          closeModal={handleClose}
          modalFooter={modalFooter()}
        >
          <p className='text-gray-700 whitespace-pre-wrap'>{message}</p>
        </ModalSkeleton>
      )}
    </>
  );
};

export default AvailabilityChangeModal;
